import React from 'react'
import "./End.css"

export const End = () => {
    return (
        <div className='voting'>
            <div className="voting_block end">
                <h2>The End</h2>
            </div>
        </div>
    )
}
